// @ts-check
/**
 * Parte un ejemplo del ejercicio ("Entrada: 5 -> Salida: Tarifa: gratuita") en
 * su entrada y su salida, para que el enunciado enseñe la salida aparte, con
 * sus saltos de línea tal cual (`components/exercise-statement.js`).
 *
 * El backend exige ese formato a cada ejemplo del banco
 * (`backend/tests/unit/test_ejemplos_ejercicios.py`, `_FORMATO`). Esa misma
 * prueba ejecuta ESTA función vía Node sobre todos los ejemplos y exige que los
 * parta igual que su expresión regular: dos copias de un formato, atadas por
 * una prueba.
 *
 * Sin imports: Node tiene que poder cargarlo.
 */

const FORMATO_EJEMPLO = /^\s*Entrada:\s*([\s\S]*?)\s*->\s*Salida:\s*([\s\S]*)$/;

/**
 * @param {string} texto
 * @returns {{ entrada: string, salida: string } | null} `null` si no sigue el
 *   formato (o no dice nada de la entrada): entonces se enseña entero.
 */
export function partirEjemplo(texto) {
  const partes = FORMATO_EJEMPLO.exec(typeof texto === 'string' ? texto : '');
  if (!partes || partes[1] === '') return null;
  return { entrada: partes[1], salida: partes[2] };
}
